// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"cde78544","86":"7a3f6c50","140":"7b29a656","147":"c47c3b5d","155":"c8cf58f9","175":"68e934de","240":"3fe5589b","373":"9b8040ef","400":"5c7f133d","464":"b34a95db","472":"335edc81","735":"a1c14a3f","741":"b304b67c","793":"e9cbf64f","918":"001af155"}[chunkId] + ".chunk.js";
};